import * as yup from 'yup';
import { Widowhood } from 'mutation/view-models/registration-widowhood';
import { AccordionEditDataControl } from 'shell/view-models/edit-data-control';
import { DateTime } from 'luxon';
import { ActType } from 'shell/constants/act-type';
import { idActRegex } from 'shell/constants/regex';
import { DocumentDigital } from 'shell/view-models/act-form';
// import { MunicipalityAnprVM } from 'shell/components/shared/municipality-list';

export const validationSchema = yup.object().shape({
  civilStatus: yup.object().shape({
    status: yup.string().nullable().required('campo obbligatorio'),
  }),
  editDataControl: yup
    .object()
    .shape({
      dateValidity: yup
        .date()
        .nullable()
        .required('campo obbligatorio')
        .typeError('Data non valida'),
    })
    .test(
      'editDataControl.dateValidity',
      'La data deve essere minore uguale al giorno corrente',
      (values) => {
        const castedValues = values as unknown as AccordionEditDataControl;

        if (castedValues?.dateValidity && castedValues?.dateValidity > DateTime.now()) {
          return new yup.ValidationError(
            'La data deve essere minore uguale al giorno corrente',
            undefined,
            'editDataControl.dateValidity'
          );
        }

        return true;
      }
    ),
  widowhood: yup
    .object()
    .shape({
      eventDate: yup.date().nullable().required('campo obbligatorio').typeError('Data non valida'),
      isForeign: yup.boolean().nullable().notRequired(),
      exceptionalPlace: yup.string().nullable(),
      municipality: yup.object().nullable().shape({
        description: yup.string().nullable().notRequired(),
      }),
      foreignState: yup.object().nullable().shape({
        id: yup.string().nullable().notRequired(),
      }),
      // start act
      actType: yup.string(),
      digital: yup
        .object()
        .nullable()
        .when('actType', {
          is: ActType.AttoDigitale,
          otherwise: yup.object().nullable(),
          then: yup
            .object()
            .nullable()
            .shape({
              idAnsc: yup
                .string()
                .nullable()
                .matches(idActRegex, 'Formato non corretto')
                .test((value) => {
                  if (value) {
                    const [year] = value.split('-');
                    const isValid = year ? Number.parseInt(year) >= 2022 : true;

                    return isValid
                      ? true
                      : new yup.ValidationError(
                          "L'idAnsc deve avere anno maggiore al 2022",
                          undefined,
                          'marriage.digital.idAnsc'
                        );
                  }
                  return true;
                })
                .required('Campo obbligatorio'),
              documentDate: yup
                .date()
                .nullable()
                .notRequired()
                .typeError('Formato non valido')
                .required('Campo obbligatorio'),
              municipality: yup.object().shape({}).nullable().required('Campo obbligatorio'),
            })
            .test((values) => {
              const castedValues = values as unknown as DocumentDigital;

              if (
                castedValues?.municipality?.id &&
                castedValues?.istatCode &&
                castedValues?.municipality?.id === castedValues.istatCode
              ) {
                return true;
              }
              return new yup.ValidationError([
                new yup.ValidationError(
                  'Non coincidono i due codici ISTAT',
                  undefined,
                  'marriage.digital.municipality'
                ),
                new yup.ValidationError(
                  'Non coincidono i due codici ISTAT',
                  undefined,
                  'marriage.digital.istatCode'
                ),
              ]);
            }),
        }),
      paper: yup
        .object()
        .nullable()
        .when('actType', {
          is: ActType.AttoCartaceo,
          otherwise: yup.object().nullable(),
          then: yup.object().shape({
            actDate: yup
              .date()
              .nullable()
              .max(
                DateTime.local().plus({ days: 1 }),
                'La data non può essere successiva alla data odierna'
              )
              .typeError('Data non valida'),
            transcribed: yup.string().nullable(),
            actMunicipality: yup.object().nullable().shape({}).required('Campo obbligatorio'),
            actYear: yup
              .number()
              .nullable()
              .required('Campo obbligatorio')
              .typeError('Sono ammesse solamente cifre'),
            actNumber: yup
              .number()
              .nullable()
              .required('Campo obbligatorio')
              .typeError('Sono ammesse solamente cifre'),
            actPart: yup
              .string()
              .nullable()
              .required('Campo obbligatorio')
              .test(
                'part-ammisible-values',
                'Gli unici valori ammessi sono 1 o 2',
                (value) => ['1', '2'].indexOf(value || '') >= 0
              ),
            actSeries: yup.string().nullable(),
            //               .required('Campo obbligatorio')
            //               .test(
            //                 'part-ammisible-values',
            //                 'Gli unici valori ammessi sono A, B o C',
            //                 (value) => ['A', 'B', 'C'].indexOf(value || '') >= 0
            //               ),
            actVolume: yup
              .string()
              .nullable()
              .when('actMunicipality.description', {
                is: (description: string) => (description || '').toLocaleLowerCase() === 'milano',
                then: yup
                  .string()
                  // .required('Campo obbligatorio')
                  .matches(/^R[0-9]{2}$/, {
                    message:
                      'Per il comune di Milano il volume è formato da R e due cifre(es. R00)',
                  }),
              }),
          }),
        }),
      // end act
    })
    .test('widowhood.exceptionalPlace', 'Campo obbligatorio', (values) => {
      const castedValues = values as unknown as Widowhood;

      if (
        castedValues?.exceptionalPlace ||
        castedValues?.municipality?.description ||
        castedValues?.foreignState?.id
      ) {
        return true;
      }

      return new yup.ValidationError('Campo obbligatorio', undefined, 'widowhood.exceptionalPlace');
    })
    .test('widowhood.municipality.description', 'Campo obbligatorio', (values) => {
      const castedValues = values as unknown as Widowhood;

      if (
        castedValues?.exceptionalPlace ||
        castedValues?.municipality?.description ||
        castedValues?.foreignState?.id
      ) {
        return true;
      }

      return new yup.ValidationError(
        'Campo obbligatorio',
        undefined,
        'widowhood.municipality.description'
      );
    })
    .test('widowhood.foreignState.id', 'Campo obbligatorio', (values) => {
      const castedValues = values as unknown as Widowhood;

      if (
        castedValues?.exceptionalPlace ||
        castedValues?.municipality?.description ||
        castedValues?.foreignState?.id
      ) {
        return true;
      }

      return new yup.ValidationError('Campo obbligatorio', undefined, 'widowhood.foreignState.id');
    }),
});
